export function registerTestimonialCarousel(Alpine) {
    Alpine.data('testimonialCarousel', () => ({
        page: 0,
        totalPages: 1,
        perPage: 3,
        _container: null,

        init() {
            this._container = this.$el.querySelector('.ik-section-testimonials__cards');
            if (!this._container) return;

            this._calcPages();

            const lg = window.matchMedia('(min-width: 992px)');
            if (lg.matches) this._lockOverflow();

            lg.addEventListener('change', (e) => {
                if (e.matches) {
                    this._lockOverflow();
                } else {
                    this._container.style.overflowX = '';
                }
                this._calcPages();
                this._go(false);
            });
        },

        next() {
            this.page = (this.page + 1) % this.totalPages;
            this._go(true);
        },

        prev() {
            this.page = (this.page - 1 + this.totalPages) % this.totalPages;
            this._go(true);
        },

        _lockOverflow() {
            this._container.style.overflowX = 'hidden';
        },

        _go(smooth) {
            if (!this._container) return;
            const pageWidth = this._container.offsetWidth;
            this._container.scrollTo({
                left: this.page * pageWidth,
                behavior: smooth ? 'smooth' : 'instant',
            });
        },

        _calcPages() {
            const total = this._container.querySelectorAll('.ik-testimonial').length;
            const lg = window.matchMedia('(min-width: 992px)').matches;
            const visible = lg ? this.perPage : 1;
            this.totalPages = Math.max(1, Math.ceil(total / visible));
            if (this.page >= this.totalPages) this.page = 0;
        },
    }));
}
